import { createMigration } from './utils';

export const migrationTo9_227 = createMigration({
    migrateVideo(video) {
        return video.withMutations((map) => {
            if (map.has('_defaultSwapTextAssetStyleSceneDesign')) {
                map.remove('_defaultSwapTextAssetStyleSceneDesign');
            }
            if (map.has('_defaultSwapFancyCaptionAssetStyleSceneDesign')) {
                map.remove('_defaultSwapFancyCaptionAssetStyleSceneDesign');
            }
        });
    },
});
